<template>
    <div class="page-users page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="24">
                    <h3 style="float: none;">用户地址</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>客户管理</el-breadcrumb-item>
                            <el-breadcrumb-item>用户地址</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
            </el-row>
            <div class="bd">
                <div class="search-block content-body">
                    <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
                        <!-- <el-form-item prop="desk_number" label="店铺编号：">
                            <el-input v-model="form_search.desk_number" size="small" placeholder="店铺编号" clearable></el-input>
                        </el-form-item> -->
                        <el-form-item prop="user_number" label="用户编号：">
                            <el-input v-model="form_search.user_number" type='number' size="small" placeholder="请输入用户编号" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="consignee_phone" label="联系电话：">
                            <el-input v-model="form_search.consignee_phone" type='number' size="small" placeholder="联系电话" clearable></el-input>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-button type="primary" class="search-btn"  size="medium" @click='searchList()'>查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;">
                            <el-table-column prop="id" align="center" label="ID" min-width="90">
                            </el-table-column>
                            <el-table-column prop="user_number" align="center" label="用户编号" min-width="160">
                                <template slot-scope="scope">
                                    <span class="user-num-span" @click="$util.goTo('/user/list',{query:{user_number:scope.row.user_number}})">{{scope.row.number}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="nick_name" align="center" label="用户昵称" min-width="140">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.custom_nick_name">{{scope.row.custom_nick_name}}</span>
                                    <span v-else>{{scope.row.nick_name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="sex_name" align="center" label="用户性别" min-width="90">
                            </el-table-column>
                            <el-table-column prop="avatar_url" align="center" label="用户头像" min-width="160">
                                <template slot-scope="scope">
                                    <img class="cursor" :src="scope.row.avatar_url" height="23" @click="dlg_preview.img_url = scope.row.avatar_url;dlg_preview.visible = true;" title="点击查看" />
                                </template>
                            </el-table-column>
                         <!--   <el-table-column prop="desk_number" align="center" label="店铺编号" min-width="140">
                            </el-table-column> -->
                            <!--<el-table-column prop="desk_name" align="center" label="店铺名称" min-width="200">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.desk_name"></my-textEllipsis>
                                </template>
                            </el-table-column>-->
                            <el-table-column prop="consignee" align="center" label="联系人" min-width="120">
                            </el-table-column>
                            <el-table-column prop="consignee_phone" align="center" label="联系电话" min-width="140">
                            </el-table-column>
                            <el-table-column prop="addr" align="center" label="配送地址" min-width="240">
                                <template slot-scope="scope">
                                    <!--<my-textEllipsis v-if="is_refresh" :content="scope.row.desk_name+scope.row.addr"></my-textEllipsis>-->
                                    <span>{{scope.row.desk_name+scope.row.addr}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="m_time" align="center" label="更新日期" min-width="160">
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.page"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
            return {
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
                form_search:{
                    user_number:'',
                    desk_number:this.$route.query.desk_number == undefined? '' : this.$route.query.desk_number,
                    consignee_phone:''
                },
                init_data: {
                    status_list: [],
                },
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        page: 1,
                        pageSize: 10,
                        total: 130
                    }
                },
                dlg_preview:{
                    visible: false,
                    img_url: ''
                }
            }
        },
        created() {
            document.title = '用户地址';
            this.getList();
        },
        methods: {
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
            getList() {
                var _this = this;
                var params = _this.form_search;
                params.p = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
                this.$client.get('/adminapi/useraddr/list', params, function(res,message){
                    _this.table_data.list = res.list;
                    _this.table_data.page_info = res.pager;
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.table_data.page_info.page = val;
                this.getList();
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            }
        }
    }
</script>
<style>

</style>
<style scoped>
    .balance-title{
        text-align: center;
        font-size: 18px;
        color: #161616;
    }
    .balance-text{
        font-size: 14px;
        color: #161616;
        padding: 20px;
        text-align: center;
        margin-bottom: 20px;
    }
    .balance-text span{
        font-size: 24px;
    }
</style>